export default __webpack_public_path__ + "806b5d3f69d95498aa739dfefb046c9e.svg";